import { useMutation, useQueryClient } from "@tanstack/react-query";
import { restoreAllEmployees as apiFn } from "../../api/apiEmployees";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useRestoreAllEmployees() {
    const qc = useQueryClient(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: restoreAllEmployees, isPending: isRestore } = useMutation({
        mutationFn: (req) => apiFn(req),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); qc.invalidateQueries({ queryKey: ["employees"] }); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); },
    });
    return { restoreAllEmployees, isRestore };
}
